<template>
    <div class="terraces-images-grid">
        <div class="grid-img" :style="'background-image:url(' + options[0].grid_img + ')'"></div>
        <div class="images-items">
            <div class="grid-item">
                <div class="item-desc">
                    <h4 v-html="options[0].cards.title"></h4>
                    <p v-html="options[0].cards.desc"></p>
                </div>
                <div class="item-img" :style="'background-image:url(' + options[0].cards.img + ')'" v-if="!isMobileGlobal"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'terraces-images-grid',
        props: ['options'],
        data () {
            return {
            }
        },
        computed: mapGetters({
            isMobileGlobal: 'loadisMobileGlobal',
        }),
    }
</script>

<style lang="scss">
    @import '@/styles/components/terraces/terraces-images-grid.scss';
    @import '@/styles/components/terraces/respond/terraces-images-grid-respond.scss';
</style>